// extracted by mini-css-extract-plugin
module.exports = {"root":"LogRoadHazardButton_root__3UhKH","icon":"LogRoadHazardButton_icon__fyOlY","plus":"LogRoadHazardButton_plus__cd_V3"};